export default __webpack_public_path__ + "static/media/AddressIcon.18a69ac9.svg";